import { ChevronLeft } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from './action';

export function RegisterForm() {
  const { toggleForm } = useAuth();

  // State lưu trữ thông tin form
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const [errors, setErrors] = useState({
    password: '',
    confirmPassword: ''
  });

  // Xử lý khi nhập liệu
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    // Reset lỗi khi người dùng nhập lại
    setErrors({ ...errors, [e.target.name]: '' });
  };

  // Xử lý khi nhấn đăng ký
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    let valid = true;
    let newErrors = { password: '', confirmPassword: '' };

    // Kiểm tra mật khẩu ít nhất 6 ký tự
    if (formData.password.length < 6) {
      newErrors.password = 'Mật khẩu phải có ít nhất 6 ký tự.';
      valid = false;
    }

    // Kiểm tra mật khẩu nhập lại có khớp không
    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Mật khẩu nhập lại không khớp.';
      valid = false;
    }

    setErrors(newErrors);

    if (valid) {
      alert('Đăng ký thành công!');
      // Thực hiện đăng ký (Gửi dữ liệu lên server)
    }
  };

  const labelClassName = 'block pb-1.5 text-xs font-bold uppercase tracking-wider text-slate-500';
  const inputClassName =
    'h-11 w-full border border-slate-200 bg-slate-50/50 rounded-xl px-4 text-sm text-slate-900 placeholder:text-slate-400 outline-none transition-all duration-200 hover:border-slate-300 hover:bg-slate-50 focus:border-[#023e8a] focus:bg-white focus:ring-4 focus:ring-[#023e8a]/10';

  return (
    <div>
      {/* Localized Form Header */}
      <div className='mb-8 text-center'>
        <h2 className='text-3xl font-extrabold tracking-tight text-slate-900'>Đăng ký</h2>
        <p className='mt-2 text-sm text-slate-500'>Tạo tài khoản mới để truy cập hệ thống TTMI ERP.</p>
      </div>

      <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
        <div>
          <label className={labelClassName}>Họ và tên</label>
          <input
            type='text'
            name='fullName'
            value={formData.fullName}
            onChange={handleChange}
            className={inputClassName}
            placeholder='Nhập họ và tên của bạn'
            required
          />
        </div>

        <div className='grid gap-4 sm:grid-cols-2'>
          <div>
            <label className={labelClassName}>Số điện thoại</label>
            <input
              type='tel'
              name='phone'
              value={formData.phone}
              onChange={handleChange}
              className={inputClassName}
              placeholder='Nhập số điện thoại'
              required
            />
          </div>
          <div>
            <label className={labelClassName}>Email</label>
            <input
              type='email'
              name='email'
              value={formData.email}
              onChange={handleChange}
              className={inputClassName}
              placeholder='Nhập địa chỉ email'
              required
            />
          </div>
          <div>
            <label className={labelClassName}>Mật khẩu</label>
            <input
              type='password'
              name='password'
              value={formData.password}
              onChange={handleChange}
              className={inputClassName}
              placeholder='Tối thiểu 6 ký tự'
              required
            />
            {errors.password && <p className='pt-1 text-xs font-semibold text-red-600'>{errors.password}</p>}
          </div>
          <div>
            <label className={labelClassName}>Nhập lại mật khẩu</label>
            <input
              type='password'
              name='confirmPassword'
              value={formData.confirmPassword}
              onChange={handleChange}
              className={inputClassName}
              placeholder='Xác nhận mật khẩu'
              required
            />
            {errors.confirmPassword && (
              <p className='pt-1 text-xs font-semibold text-red-600'>{errors.confirmPassword}</p>
            )}
          </div>
        </div>

        <button
          type='submit'
          className='mt-4 h-11 w-full rounded-xl bg-[#023e8a] text-sm font-bold text-white shadow-sm transition-all duration-150 hover:bg-[#012e66] focus:outline-none focus:ring-4 focus:ring-[#023e8a]/20 active:scale-[0.985]'
        >
          Đăng ký
        </button>

        <div className='flex items-center justify-center pt-2 text-center'>
          <button
            type='button'
            onClick={() => toggleForm('login')}
            className='flex items-center justify-center gap-1 text-xs font-bold text-slate-500 transition-colors hover:text-slate-700'
          >
            <ChevronLeft className='h-4 w-4 stroke-[2.5]' />
            Quay lại đăng nhập
          </button>
        </div>
      </form>
    </div>
  );
}
